export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-7.584544d1.svg";